<template>
  <div class="step">
    <h2>Chi sei?</h2>
    <p class="subtitle text-medium">
      Scegli il profilo a cui appartieni
    </p>
    <div class="fieldset">
      <model-list-select
        v-model="params.selected"
        :list="profiles"
        option-value="id"
        option-text="label"
        placeholder="Seleziona il tuo profilo"
      />
      <Input
        v-if="showOtherLabel"
        v-model="customLabel"
        type="text"
        placeholder="Specifica"
      />
      <p
        v-if="showPrivateAlert"
        class="text-small secondary"
      >
        <strong>Attenzione: l'area riservata di SACE è pensata primariamente per le aziende quindi, 
		scegliendo di non registrarti con un codice fiscale aziendale beneficerai di un'esperienza molto limitata.</strong>
		Ti consigliamo quindi di registrarti, qualora disponibile, con un codice fiscale aziendale per usufruire appieno dei prodotti, 
		servizi ed eventi.<strong> Ti ricordiamo che non sarà possibile in seguito alla registrazione cambiare ad azienda, se non attraverso il nostro customer care</strong> con un processo che richiederà alcuni giorni.
      </p>
    </div>
    <div class="actions">
      <button
        class="button primary"
        :disabled="disabled"
        @click="!disabled ? navigate('next') : null"
      >
        Avanti
      </button>
      <button
        v-if="isCompleteProfile"
        class="back"
        @click="navigate('prev')"
      >
        Torna indietro
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import { ModelListSelect } from 'vue-search-select';

import { GestioneProfili } from '../../common/utenze';

import Input from '../shared/InputComponent.vue';

Vue.use(VueLodash, { lodash });

const _ = require('lodash');

export default {
  name: 'Profilo',
  components: {
    ModelListSelect,
    Input,
  },
  props: {
    preset: {
      type: Object,
      default: () => {},
    },
    profiles: {
      type: Array,
      default: () => [],
    },
    isCompleteProfile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      params: {
        selected: {
          id: null,
        },
      },
      customLabel: null,
    };
  },
  computed: {
    showOtherLabel() {
      return this.params.selected.id === '99';
    },
    disabled() {
      if (this.showOtherLabel) {
        return _.isEmpty(this.params.selected) || !this.customLabel;
      }
      return this.params.selected.id == null;
    },
    showPrivateAlert() {
      return _.includes(GestioneProfili.PrivatiRegistazione, this.params.selected.id);
    },
  },
  watch: {
    preset: {
      handler(v) {
        if (!_.isEmpty(v)) {
          this.params.selected = v.selected;
          this.customLabel = v.customLabel;
        }
      },
      deep: true,
      immediate: true,
    },
    params: {
      handler(v) {
        if (v.selected.id !== '99') {
          this.customLabel = null;
        }
        this.setProfile();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$emit('push-event');
  },
  created() {},
  methods: {
    setProfile() {
      const param = {
        selected: this.params.selected,
        customLabel: this.customLabel,
      };
      this.$emit('set-profile', param);
    },
    navigate(step) {
      const obj = {
        params: {
          selected: this.params.selected,
          customLabel: this.customLabel,
        },
        step: 'profile',
        navigate: step,
      };
      this.$emit('navigate', obj);
    },
  },
};
</script>
